/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { DashboardInterestMeterCardMobile, DashboardInterestMeterChartMobile } from "bd-web-components"

interface InterestMeterContainerProps {
  interestMeter: any
}

const InterestMeterContainer: React.FC<InterestMeterContainerProps> = ({ interestMeter }) => {
  let interestMeterData: any = null

  if (interestMeter) {
    interestMeterData = {
      sales: interestMeter.quantidadeVendas,
      percentage: {
        datasets: interestMeter.percentualInteresse ? [{ data: [interestMeter.percentualInteresse] }] : [{ data: [0] }],
      },
      visits: interestMeter.quantidadeVisitas,
      chartData: {
        datasets: [
          {
            data: 90,
          },
        ],
      },
      chartDataParam: interestMeter.percentualInteresse ? interestMeter.percentualInteresse : 0
    };
  }

  return (
    <DashboardInterestMeterCardMobile
      title="Medidor de Interesse"
      percentage={interestMeterData.percentage}
      visitsData={interestMeterData.visits}
      salesData={interestMeterData.sales}
      lowConversionMsg={'Os preços podem estar mais caros que o esperado pelo público.'}
      middleConversionMsg={'Os preços estão dentro do esperado pelo público.'}
      highConversionMsg={'Os preços podem estar mais baratos que o esperado pelo público.'}
      extremeConversionMsg={'Dados inconsistentes para calcular a conversão'}
  >
    <DashboardInterestMeterChartMobile chartData={{ datasets: [{ data: [interestMeterData.chartDataParam.toFixed(2)] }] }} />
  </DashboardInterestMeterCardMobile>
  )
}

export default InterestMeterContainer
